import { render, staticRenderFns } from "./AddNewWSU.vue?vue&type=template&id=4850c996&"
import script from "./AddNewWSU.vue?vue&type=script&lang=js&"
export * from "./AddNewWSU.vue?vue&type=script&lang=js&"
import style0 from "./AddNewWSU.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports